module.exports = __webpack_public_path__ + "img/solutionImg2.3fdab83c.png";